import {Icon} from '@startlibs/components';
import {getColor} from '@startlibs/utils';
import React from 'react'
import {FormattedMessage} from 'react-intl'
import styled from 'styled-components';
import {SUPER} from '../../enums/UserRole'
import {ScrollToTop} from '../../components/ScrollToTop'
import {
  Sidebar,
  SidebarCard,
  SidebarContainer,
  SidebarTitle,
  StepLink,
  useMobileSidebar
} from '../../components/Sidebar';
import {WithLazyResource} from '../../hooks/useSuspense'
import {lazyUserInfo} from '../../components/WithProvider'
import { useMatch } from '../../hooks/useMatch';

const MobilePageTitle = styled.h4`
  padding-left: 1.5rem;
  font-size: 16px;
  margin-bottom: 0;
  flex-shrink; 0;
  margin-bottom: 0;
  color: ${getColor('main')};
`

const MobileCollapsedHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
`

const ChevronDownIcon = styled(Icon)`
  font-size: 20px;
  margin-right: 1.75rem;
  color: #5a5a5a;
`

const getPageTitle = (page) => {
  switch (page) {
    case "staff":
      return <FormattedMessage description="Staff management label" defaultMessage="Staff management"/>
    case "divisions":
      return "Divisions settings"
    case "notifications":
      return "Notification settings"
    case "export":
      return "Data export"
    case "analytics":
      return "Analytics"
    case "jurisdictions":
      return "Jurisdictions"
    case "audit":
      return "Audit log"
    case "paymentfees":
      return "Payment fees"
    default:
      return "Control panel"
  }
}
export const ControlPanelSidebar = () => {
  
  const match = useMatch("/admin/control/:page")
  const page = match?.params && match?.params.page

  const [isCollapsed, expandedToggle] = useMobileSidebar(page)



  const mobilePageTitle = (
    <MobileCollapsedHeader>
      <MobilePageTitle>
        {getPageTitle(page)}
      </MobilePageTitle>
      <ChevronDownIcon icon="arrow-down-line"  />
    </MobileCollapsedHeader>
  )
  
    return <SidebarContainer 
      css={{paddingTop: '8rem'}}
      collapsed={isCollapsed}
      onClick={e => e.target === e.currentTarget && expandedToggle.close()}
      >
      <ScrollToTop when={page}/>
      <Sidebar>
        <SidebarCard
          onClick={isCollapsed ? expandedToggle.open : undefined}
          collapsed={isCollapsed && mobilePageTitle}
        >
          <div className="sidebar-heading">
            <SidebarTitle>Control Panel</SidebarTitle>
          </div>
          <StepLink
            to="staff"
            selected={page === "staff"}
          ><Icon icon="users-line"/><FormattedMessage description="Staff management label" defaultMessage="Staff management"/></StepLink>
          <StepLink
            to="divisions"
            selected={page === "divisions"}
          ><Icon icon="divisions"/> Divisions settings</StepLink>
          <WithLazyResource value={lazyUserInfo}>{userInfo => <>
            {
              userInfo.role === SUPER && <>
              <StepLink
                to="notifications"
                selected={page === "notifications"}
              ><Icon icon="mail-line"/> Notification settings</StepLink>
              <StepLink
                to="export"
                selected={page === "export"}
              ><Icon icon="csv"/> Data export</StepLink>
              <StepLink
                to="analytics"
                selected={page === "analytics"}
              ><Icon icon="analytics"/> Analytics</StepLink>
              <StepLink
                to="jurisdictions"
                selected={page === "jurisdictions"}
              ><Icon icon="jurisdictions"/> Accepted jurisdictions</StepLink>
              <StepLink
                to="paymentfees"
                selected={page === "paymentfees"}
              ><Icon icon="payment"/> Payment fees</StepLink>
              <StepLink
                to="audit"
                selected={page === "audit"}
              ><Icon icon="audit"/> Audit log</StepLink>
              <StepLink
                to="intake-forms"
                selected={page === "intake-forms"}
              ><Icon icon="intake-forms"/> Intake form settings</StepLink>
              <StepLink
                to="case-report"
                selected={page === "case-report"}
              ><Icon icon="report"/> Case report settings</StepLink>
            </>}
          </>}</WithLazyResource>
        </SidebarCard>
      </Sidebar>
    </SidebarContainer>
}
